'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _nodeFetch = require('node-fetch');

var _nodeFetch2 = _interopRequireDefault(_nodeFetch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('es6-promise').polyfill();

function post(body) {
    return new Promise(function (resolve, reject) {
        var options = {
            method: 'POST',
            body: JSON.stringify(body)
        };

        (0, _nodeFetch2.default)('https://eventemitter.simplybenefits.ca', options).then(function (res) {
            return res.json();
        }).then(function () {
            resolve('success');
        }).catch(function (err) {
            reject(err);
        });
    });
}

exports.default = post;